import React from "react";

/* 百分比环形指标：value 0–100 或 null（无数据） */
export function PercentRing({ value, label, sub, color = "#4F6BFF", testid, size = 84 }) {
  const r = (size - 10) / 2;
  const c = 2 * Math.PI * r;
  const v = value == null ? 0 : Math.max(0, Math.min(100, value));
  const dash = (v / 100) * c;
  return (
    <div className="flex flex-col items-center gap-1.5 min-w-[104px]" data-testid={testid} data-value={value == null ? "null" : v}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e2e8f0" strokeWidth="8" />
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={value == null ? "#cbd5e1" : color} strokeWidth="8" strokeLinecap="round"
            strokeDasharray={`${dash} ${c - dash}`} style={{ transition: "stroke-dasharray .6s ease" }} />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className={`font-extrabold ${value == null ? "text-slate-300 text-sm" : "text-slate-900 text-lg"}`}>{value == null ? "—" : `${v}%`}</span>
        </div>
      </div>
      <p className="text-xs font-semibold text-slate-700 text-center leading-tight">{label}</p>
      {sub && <p className="text-[11px] text-slate-400 text-center leading-tight">{sub}</p>}
    </div>
  );
}
